import React, {useEffect, useState} from 'react';
import {Box, Button, Grid, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import Tab from "@mui/material/Tab";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import 'moment/locale/ru'
import {getOneClientRequest} from "../../redux/actions/clientRequest/clientRequestActions";
import Loader from "../Shared/Loader";
import TableClientRequest from "./TableClientRequest";
import {useHistory} from "react-router-dom";
import {CONTRACT_DETAILS_ROUTE, CONTRACT_ROUTE, DEAL_ADD_ROUTE} from "../../routes/const";
import {clientCRUD, serviceCRUD, serviceScheduleCRUD} from "../../http/CRUD";

moment.locale('ru')

function TableTabClientRequest({rowsPage, locale}) {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const history = useHistory()
    const [value, setValue] = useState(0);
    const {loading} = useSelector((state) => state.clientRequest)
    const [clientRequestOne, setClientRequestOne] = useState([])
    const [localLoading, setLocalLoading] = useState(true)
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        (async function () {
            try {
                setLocalLoading(true)
                const res = await dispatch(getOneClientRequest(rowsPage.id))
                if (res) {
                    let enrichedResult = {...res};

                    // Подгружаем данные клиента (person / legalPerson)
                    if (res.clientId && (!res.client?.person && !res.client?.legalPerson)) {
                        try {
                            const clientData = await clientCRUD.get(res.clientId);
                            enrichedResult.client = clientData;
                        } catch (e) {
                            console.error("Ошибка загрузки клиента:", e);
                        }
                    }

                    // Подгружаем данные услуг и графиков в спецификациях
                    if (res.specifications?.length) {
                        const enrichedSpecs = await Promise.all(
                            res.specifications.map(async (spec) => {
                                const enrichedSpec = {...spec};
                                try {
                                    if (spec.serviceId && !spec.service?.name) {
                                        enrichedSpec.service = await serviceCRUD.get(spec.serviceId);
                                    }
                                    if (spec.scheduleId && !spec.schedule?.name) {
                                        enrichedSpec.schedule = await serviceScheduleCRUD.get(spec.scheduleId);
                                    }
                                } catch (e) {
                                    console.error("Ошибка загрузки данных спецификации:", e);
                                }
                                return enrichedSpec;
                            })
                        );
                        enrichedResult.specifications = enrichedSpecs;
                    }

                    setClientRequestOne(enrichedResult);
                }
            } catch (e) {
                console.error("Ошибка загрузки заявки:", e);
            } finally {
                setLocalLoading(false)
            }
        }())
    }, [dispatch, rowsPage.id])

    const [type, setType] = useState(1)

    useEffect(() => {
        // Определяем тип: если есть person - физлицо (1), если legalPerson - юрлицо (2)
        if (clientRequestOne?.client?.user?.typeId) {
            setType(clientRequestOne.client.user.typeId)
        } else if (clientRequestOne?.client?.person) {
            setType(1)
        } else if (clientRequestOne?.client?.legalPerson) {
            setType(2)
        }
    }, [clientRequestOne?.client])

    const handleCreateContract = () => {
        
        history.push(CONTRACT_DETAILS_ROUTE, {
            client: clientRequestOne
        })
    }

    const handleCreateDeal = () => {
        history.push(DEAL_ADD_ROUTE, {
            client: clientRequestOne
        })
    }


    return (
        <>
            <Tabs
                value={value}
                onChange={handleChange}
            >
                <Tab label="Клиент"/>
                <Tab label="Выбранные услуги"/>
            </Tabs>
            {value === 0 && <>
                {(loading || localLoading) ? <Loader/> : <>
                    {type === 1 && clientRequestOne?.client?.person && <>
                        <Grid container sx={{borderBottom: '1px solid #eee'}}>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0', fontWeight: 'bold'}}>ФИО</Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0'}}>
                                    {clientRequestOne.client.person.fullName || 
                                     [clientRequestOne.client.person.surname, clientRequestOne.client.person.name, clientRequestOne.client.person.patronymic].filter(Boolean).join(' ') || 
                                     'Значение не задано'}
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container sx={{borderBottom: '1px solid #eee'}}>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0', fontWeight: 'bold'}}>Телефон</Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0'}}>
                                    {clientRequestOne.client.person.phoneNumber || 'Значение не задано'}
                                </Box>
                            </Grid>
                        </Grid>
                    </>}
                    {type === 2 && clientRequestOne?.client?.legalPerson && <>
                        <Grid container sx={{borderBottom: '1px solid #eee'}}>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0', fontWeight: 'bold'}}>Наименование</Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0'}}>
                                    {clientRequestOne.client.legalPerson.name || 'Значение не задано'}
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container sx={{borderBottom: '1px solid #eee'}}>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0', fontWeight: 'bold'}}>Телефон</Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{padding: '5px 0'}}>
                                    {clientRequestOne.client.legalPerson.phoneNumber || 'Значение не задано'}
                                </Box>
                            </Grid>
                        </Grid>
                    </>}
                </>}
                <Grid sx={{marginTop: 2, marginBottom: 2}}>
                    <Button onClick={handleCreateContract}>Создать договор</Button>
                    <Button onClick={handleCreateDeal}>Создать сделку</Button>
                </Grid>
            </>}
            {value === 1 && <>
                {clientRequestOne?.specifications && <TableClientRequest specification={clientRequestOne?.specifications}/>}
            </>}
        </>
    )
}

export default TableTabClientRequest;